import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateHomework } from '@services/registry';

export function useUpdateHomework({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ homeworkId, patch }) => {
            return await updateHomework({ tenantId, homeworkId, patch });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['homeworks', tenantId] });
        },
    });
}
